/* =============================================================================
   CATÁLOGO DE HABITACIONES · los datos
   Es el ÚNICO archivo que hay que tocar para agregar, quitar o cambiar una
   habitación o sus fotos. habitaciones.js lo lee y arma la página.

   Cada TIPO:
     id         nombre interno; sus textos viven en i18n.js como
                rooms.<id>.name / .descShort / .detail (ES/EN)
     huespedes  capacidad (número) o null si no se declara
     unidades   las habitaciones reales de ese tipo

   Cada UNIDAD (habitación), creada con hab(numero, sufijos, rasgos):
     numero     cómo la llama el hotel (p. ej. '204'); se muestra en su tarjeta
     sufijos    qué fotos tiene, en el orden del carrusel. La portada es la
                primera. '' es la foto principal (204.jpg), '-2' la segunda,
                '-bano' el baño… Cada foto se publica en
                assets/img/rooms/optim/<numero><sufijo>.webp
     rasgos     lo que distingue a ESA habitación de las otras del mismo
                tipo. Solo claves del vocabulario de abajo (traducidas en
                i18n.js como rasgo.<clave>). Vacío = no se muestra nada:
                mejor nada que un dato inventado.

   Vocabulario de rasgos: jardin, balcon, terraza, tina, jacuzzi,
   primerpiso, tranquila, vista.

   Del TIPO, además (rediseño 2026-10-29, solo los usa la página Habitaciones):
     portada    la foto grande del tipo: { numero, sufijo, forma } — una de sus
                habitaciones; forma 'arco' (vertical, en el nicho) o 'h'
                (horizontal, recta). El pie dice de qué habitación es.
     destacados claves i18n de lo que decide la elección (cama, jacuzzi…),
                tomado de la descripción del tipo. Nada que no diga ya el texto.

   FOTOS: los originales (PNG/JPG de 2–3 MB) viven en assets/img/rooms/ y no
   se cargan nunca. Para agregar una foto: guardarla como <numero>-N.jpg o
   <numero>-bano.jpg, correr scripts/optimizar-imagenes.py y sumar su sufijo
   en la habitación. Ver docs/HABITACIONES.md.
   ============================================================================= */
(function () {
  var R = '/assets/img/rooms/optim/';

  function hab(numero, sufijos, rasgos) {
    return {
      numero: numero,
      fotos: sufijos.map(function (s) { return R + numero + s + '.webp'; }),
      rasgos: rasgos || []
    };
  }

  // El orden de los tipos es el de la página (y el que esperan los tests).
  // Dentro de cada tipo, las habitaciones van por número.
  window.LG_HABITACIONES = [
    { id: 'suite', huespedes: null,
      portada: { numero: '104', sufijo: '-3', forma: 'arco' },
      destacados: ['rasgo.jacuzzi', 'rd.habitaciones.dato.salaEstar', 'rd.habitaciones.dato.accesoJardin'],
      unidades: [
      // Jacuzzi: confirmado y visible en sus fotos (solo las dos suites).
      hab('104', ['', '-2', '-3', '-bano-2', '-bano'], ['jacuzzi']),
      hab('212', ['', '-2', '-3', '-bano-2', '-bano'], ['jacuzzi'])
    ] },
    { id: 'semisuite', huespedes: null,
      portada: { numero: '214', sufijo: '-2', forma: 'h' },
      destacados: ['rd.habitaciones.dato.areaEstar', 'rasgo.jardin'],
      unidades: [
      hab('211', ['', '-banos']),
      hab('214', ['', '-2', '-3', '-bano'])
    ] },
    { id: 'matrimonial', huespedes: 2,
      portada: { numero: '209', sufijo: '', forma: 'arco' },
      destacados: ['rd.habitaciones.dato.camaKing', 'rasgo.jardin'],
      unidades: [
      hab('105', ['', '-2', '-bano']),
      hab('203', ['', '-bano']),
      hab('207', ['', '-banos']),
      hab('209', ['', '-2', '-banos'])
    ] },
    { id: 'triple', huespedes: 3,
      portada: { numero: '208', sufijo: '-2', forma: 'h' },
      destacados: ['rd.habitaciones.dato.tresCamas'],
      unidades: [
      hab('205', ['', '-bano']),
      hab('208', ['', '-2', '-bano'])
    ] },
    { id: 'doble', huespedes: 2,
      portada: { numero: '101', sufijo: '-2', forma: 'h' },
      destacados: ['rd.habitaciones.dato.dosCamas'],
      unidades: [
      hab('101', ['', '-2', '-bano']),
      hab('106', ['', '-2', '-banos']),
      hab('210', ['', '-bano'])
    ] },
    { id: 'individual', huespedes: 1,
      portada: { numero: '201', sufijo: '-3', forma: 'arco' },
      destacados: [],
      unidades: [
      hab('103', ['', '-bano']),
      hab('107', ['', '-banos']),
      hab('201', ['', '-2', '-3', '-bano']),
      hab('204', ['', '-2', '-bano']),
      hab('206', ['', '-2', '-3'])
    ] }
  ];
})();
